<nz-rate [ngModel]="config.value" nzAllowHalf [nzDisabled]="config.disabled"></nz-rate>
